import FormTextField from '../../2compounds/FormTextField'
import PhoneField from '../../2compounds/PhoneField'
import DescriptionField from '../../2compounds/DescriptionField'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { CancelButton, NextButton, Text } from '../../1elements'
import {
  validateClientName, validateDescription, validateEndCustomer,
  validatePhoneNumber, validateRequiredEmail
} from '../../../services/util/editChecks'
import { useEffect, useState } from 'react'
import ButtonLayoutDiv from '../../4layout/ButtonLayoutDiv'

const ClientTab = ({ clientData, updateClientData, showError, onCancel, onNextClient, disabled }) => {
  const classes = useStyles()
  const [duplicate, setDuplicate] = useState('')

  useEffect(() => {
    if (!disabled) {
      validateClientName(clientData.accountName)
        .then((res) => {
          setDuplicate(res)
        })
    }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [clientData.accountName])

  return (
    <div className={classes.root}>
      <Text type='tabHeadingSecondary'>Create a new client profile</Text>
      <div className={classes.formDiv}>
        <FormTextField
          label='Name' required hint='Max. 45 characters' value={clientData.accountName}
          onChange={(newValue) => updateClientData('accountName', newValue)}
          validation={showError && duplicate} disabled={disabled}
        />

        <div className={classes.discriptionWrapperDiv}>
          <DescriptionField
            label='Description' rows={5} hint='Max. 255 characters'
            value={clientData.accountDescription}
            onChange={(newValue) => updateClientData('accountDescription', newValue)}
            validation={showError && validateDescription(clientData.accountDescription)}
            disabled={disabled}
          />
        </div>  

         <div className={classes.phoneEmailDiv}>
         
         <div className={classes.phoneWrapperDiv}>
          <PhoneField
            label ='Phone Number'
            value={clientData.accountPhoneNumber}
            onChange={(newValue) => updateClientData('accountPhoneNumber', newValue)}
            validation={showError && validatePhoneNumber(clientData.accountPhoneNumber)}
            disabled={disabled}
          />
         </div> 

        <FormTextField
          label='Email' value={clientData.accountEmail} required
          onChange={(newValue) => updateClientData('accountEmail', newValue)}
          validation={showError && validateRequiredEmail(clientData.accountEmail)}
          disabled={disabled}
        />
        </div>

        <FormTextField
          label='End Customer' hint='Max. 50 characters' required value={clientData.endCustomerName}
          onChange={(newValue) => updateClientData('endCustomerName', newValue)}
          validation={showError && validateEndCustomer(clientData.endCustomerName)}
          disabled={disabled}
        />
     
      </div>

      <ButtonLayoutDiv>
        {onCancel && <CancelButton onClick={onCancel} />}
        <NextButton onClick={onNextClient} />
      </ButtonLayoutDiv>
    </div>
  )
}

export default ClientTab

const useStyles = makeStyles({
  root: {
    padding: '20px',
  },
  formDiv: {
    margin: '20px 0'
  },
  discriptionWrapperDiv:{
    width:400
  },
  phoneEmailDiv:{
    display:"flex",
    justifyContent:'start'
  },
  phoneWrapperDiv:{
    marginRight:'10px'
  }

})
